import { RoutablePage, MagicConfigMixin, ContentMixin } from '@gig/magic-common';
import { __extends, __awaiter, __generator, __decorate, __metadata } from 'tslib';
import { Watch, Emit, Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { FAQ_NAMESPACE } from '../../store/modules/faq/faq.store.js';
import { store } from '../../store/index.js';

var faqModule = namespace(FAQ_NAMESPACE);
/**
 * Component displaying list of FAQ categories from CMS linking to entries
 * of the specific category
 */
var FaqCategoriesComponent = /** @class */ (function (_super) {
    __extends(FaqCategoriesComponent, _super);
    function FaqCategoriesComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FaqCategoriesComponent.prototype.fetchFAQData = function () {
        return __awaiter(this, void 0, void 0, function () {
            var e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        this.onContentLoadInit();
                        return [4 /*yield*/, this.fetchCategories(this.magicConfig.language)];
                    case 1:
                        _a.sent();
                        this.onContentLoad(this.categories);
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.onContentLoadError(e_1);
                        this.routeTo({ route: RoutablePage.NOT_FOUND });
                        console.error(e_1);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Emitted when FAQ categories list was successfully loaded.
     * Provides loaded list
     */
    FaqCategoriesComponent.prototype.onContentLoad = function (categories) {
        return categories;
    };
    __decorate([
        faqModule.Getter('isLoading'),
        __metadata("design:type", void 0)
    ], FaqCategoriesComponent.prototype, "isLoading", void 0);
    __decorate([
        faqModule.Getter('categories'),
        __metadata("design:type", void 0)
    ], FaqCategoriesComponent.prototype, "categories", void 0);
    __decorate([
        faqModule.Action('fetchCategories'),
        __metadata("design:type", Function)
    ], FaqCategoriesComponent.prototype, "fetchCategories", void 0);
    __decorate([
        Watch('magicConfig.language', { immediate: true }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], FaqCategoriesComponent.prototype, "fetchFAQData", null);
    __decorate([
        Emit('contentLoad'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Array]),
        __metadata("design:returntype", void 0)
    ], FaqCategoriesComponent.prototype, "onContentLoad", null);
    FaqCategoriesComponent = __decorate([
        Component({
            name: 'faq-categories',
            store: store,
        })
    ], FaqCategoriesComponent);
    return FaqCategoriesComponent;
}(Mixins(MagicConfigMixin, ContentMixin)));

export default FaqCategoriesComponent;
